<template>
  <ax-dialog 
    ref="dialog"
    title="Well termination" 
    subtitle="Define well termination strategy"
    icon="mdi-chart-gantt" 
    size="medium" 
    :disabled="disabled" 
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text style="overflow:hidden">
        <v-radio-group class="mb-5"
          :hint="termination.method == 'duration' ? 'Terminate type wells after specified time duration' : termination.method == 'production' ? 'Terminate type wells when production reaches specified value' : 'Terminate type wells when economic calculations reach specified threshold'" 
          persistent-hint v-model="termination.method" row hide-details>
          <template v-for="option in termination.options">
            <v-radio :key="option.value" :label="option.text" :value="option.value" :disabled="option.disabled"></v-radio>
          </template>
        </v-radio-group>

        <template v-if="termination.method == 'duration'">
          <v-text-field
            v-model.number="termination.duration.value"
            :hint="`Terminate type wells after ${Math.round(termination.duration.value/12)} years`"
            suffix="months"
            type="number" hide-spin-buttons
            persistent-hint
          />
        </template>

        <template v-if="termination.method == 'production'">
          <v-text-field
            v-model.number="termination.production.value"
            :suffix="`${ target_units }`"
            type="number" hide-spin-buttons
            :hint="`Terminate type wells as production falls below ${termination.production.value} ${ target_units }`"
            persistent-hint
          />
        </template>

        <template v-if="termination.method == 'decline'">
          <v-text-field
            v-model.number="termination.decline.value"
            :hint="`Terminate wells after ${termination.decline.value}% annual decline rate`"
            suffix="% annual"
            type="number" hide-spin-buttons
            persistent-hint
          />
        </template>
      </v-card-text>
    </template>
    <template slot="submit_text"> Terminate </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgWellTermination",
  props: {
    aggregates: { type: Boolean, required: true },
    termination: { type: Object, required: true },
    target_units: { type: String, required: true },
    approach: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    AxDialog
  },
  data() {
    return {
      // termination: null
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.termination)
    }
  }
}
</script>